import React from 'react';
import { Button, message } from 'antd';
import useGraphqlService from "../../../util/useGraphqlService";
import {BROADCAST_SCREEN_UPDATE} from "../../../constants/graphql/screenQueries";

const BroadcastBucketPullButton = ({ selectedBucketPull }) => {
    const { sendGraphqlRequest } = useGraphqlService();

    const handleBroadcast = async () => {
        if (!selectedBucketPull?.paperName) {
            message.error("No bucket pull selected!");
            return;
        }

        try {
            await sendGraphqlRequest(BROADCAST_SCREEN_UPDATE, { input: { payload: { entry: selectedBucketPull, type: 'bucketPull' } } }); // Adjust according to actual GraphQL schema

            message.success("Bucket pull broadcast successfully!");
        } catch (error) {
            console.error("Failed to broadcast bucket pull:", error);
            message.error("Failed to broadcast bucket pull.");
        }
    };

    return (
        <Button type="primary" onClick={handleBroadcast} disabled={!selectedBucketPull?.paperName}>
            Send to Screen
        </Button>
    );
};

export default BroadcastBucketPullButton;
